import { FC, memo } from 'react';
import { IRequestStatus } from '../../types';
import { StatusContainer, StatusCircle } from './status.styled';
import { Text } from '../../components-v4';

type Props = {
  status: IRequestStatus;
  statusRu: string;
};

export const Status: FC<Props> = memo(({ status, statusRu }) => {
  return (
    <StatusContainer status={status}>
      <StatusCircle status={status} />
      <Text variant="body-14" color="gray.800">
        {statusRu}
      </Text>
    </StatusContainer>
  );
});
